export const SAVE_DEFAULT_URBN_STORE = 'SAVE_DEFAULT_URBN_STORE';
export const UPDATE_DEFAULT_URBN_STORE_POOLS = 'UPDATE_DEFAULT_URBN_STORE_POOLS';

export function saveDefaultUrbnStore(defaultStore, meta = {}) {
    return {
        type: SAVE_DEFAULT_URBN_STORE,
        meta: meta,
        payload: {
            productBopis: {
                defaultStore: defaultStore
            }
        }
    };
}

export function updateDefaultUrbnStorePools(defaultStore, meta = {}) {
    return {
        type: UPDATE_DEFAULT_URBN_STORE_POOLS,
        meta: meta,
        payload: {
            productBopis: {
                defaultStore: defaultStore
            }
        }
    };
}
